import React from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { FilterErrorIconSvg } from 'apps/sigma2-ui/src/filters-v2/components/FilterErrorIcon';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';

export interface FilterBoxErrorProps {
  /**
   * The error message translated content
   */
  errorTranslatedContent: TranslatedContent;
}

export const FilterBoxError = ({
  errorTranslatedContent,
}: FilterBoxErrorProps) => {
  return (
    <div className={'block'}>
      <span className={'line-clamp-3 text-red-600'}>
        <FilterErrorIconSvg
          svg={{
            className: 'w-4 h-4 mr-2 inline-block',
          }}
        />

        <S2Typography
          as={'span'}
          translatedContent={errorTranslatedContent}
          variant={'small-label'}
          textColorVariant={'red-600'}
        />
      </span>
    </div>
  );
};
